import { Controller } from "stimulus"
import debounce from 'lodash/debounce'
import { post } from '@rails/request.js'

export default class extends Controller {
  static targets = ["form", "input"]

  initialize() {
    this.attempt = debounce(this.attempt, 300).bind(this)
  }

  attempt(event) {
    post("/block/search", {
      query: { query: event.target.value },
      responseKind: 'turbo-stream'
    })
  }
}
